// extracted by mini-css-extract-plugin
module.exports = {"container":"container--3ke4T8","title":"title--2-p9gU","action":"action--1vbsJW","content":"content--2L8u54","divider":"divider--1d2TN0"};